import './header.css';

export default function Editor({blocksData, setBlocksData}){

    const downloadBlocksData = () => {
        const element = document.createElement("a");
        const file = new Blob([JSON.stringify(blocksData, null, 2)], {type: 'text/json'});
        element.href = URL.createObjectURL(file);
        element.download = "blockdata.json";
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
    }

    const handleFileChange = (event) => {
        console.log("change!!!")
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            setBlocksData(JSON.parse(e.target.result));
        };

        reader.readAsText(file);
    };

    return (
        <div className="HeaderWrapper">
            <h1 className="HeaderText">
                WikiBlocks
            </h1>

            <button 
                className='HeaderButton'
                onClick={downloadBlocksData}>Save
            </button>
            <label htmlFor="file-upload" className="HeaderButton">
                Upload
            </label>
            <input id="file-upload" type="file" onChange={(e) => handleFileChange(e)} />
        </div>
    )
}